import React from 'react';
import PropTypes from 'prop-types';
import Translate from './Translate';
import TextInput from './formComponents/TextInput';
import BookingStep from './BookingStep';
import AgencySubIdHOC from '../hoc/AgencySubIdHOC';

const AgencySubId = props => (
  <section className="booking-step booking-agency-sub-id card" id="booking-agency-sub-id">
    <div className="booking-step__inner">
      <div className="booking-step__inner2">
        <h2 className="card__header">
          <span className="card__header-prefix">
{props.stepIndex}
/
{props.stepTotal}
          </span>
          <Translate content="Membership code" />
        </h2>
        <section className="card__body" id="AgencySubId">
          <div className="form-field agency-sub-id">
            <label
              className="form-label agency-sub-id__label"
              htmlFor="agency-sub-id"
            >
              <Translate content="Travel agency / employee code" />
            </label>
            <TextInput
              className="text-input agency-sub-id__input"
              errorText={props.error}
              name="agency-sub-id"
              onChange={props.onChange}
              validate={props.validate}
              value={props.agencySubId}
            />
          </div>
        </section>
      </div>
    </div>
  </section>
);


AgencySubId.PropTypes = {
  agencySubId:PropTypes.string.isRequired,
  error:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  validate:PropTypes.func.isRequired,
  stepIndex:PropTypes.number.isRequired,
  stepTotal:PropTypes.number.isRequired,
};

export default AgencySubIdHOC(BookingStep(AgencySubId));
